var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.667 14.7713C28.667 13.5832 28.5709 12.7162 28.3629 11.8171H14.8389V17.1796H22.7772C22.6172 18.5123 21.7529 20.5193 19.8323 21.8679L19.8054 22.0474L24.0815 25.3706L24.3777 25.4002C27.0985 22.8795 28.667 19.1706 28.667 14.7713",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8406 28.9004C18.7297 28.9004 21.9946 27.6159 24.3794 25.4003L19.834 21.8679C18.6177 22.7189 16.9852 23.3129 14.8406 23.3129C11.0315 23.3129 7.7985 20.7922 6.64604 17.3081L6.47712 17.3225L2.0308 20.7745L1.97266 20.9367C4.34135 25.6571 9.20683 28.9004 14.8406 28.9004Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6434 17.3081C6.33932 16.409 6.16333 15.4456 6.16333 14.4502C6.16333 13.4547 6.33932 12.4914 6.6274 11.5922L6.61935 11.4008L2.11732 7.89331L1.97002 7.9636C0.993769 9.92242 0.433594 12.1221 0.433594 14.4502C0.433594 16.7783 0.993769 18.9778 1.97002 20.9367L6.6434 17.3081",
    fill: "#FFD584"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8406 5.58737C17.5453 5.58737 19.3698 6.75944 20.4102 7.7389L24.4754 3.75705C21.9787 1.42897 18.7297 0 14.8406 0C9.20682 0 4.34134 3.24324 1.97266 7.9636L6.63004 11.5923C7.79849 8.10816 11.0314 5.58737 14.8406 5.58737",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.de61b552188feb109a8feb447c0de69f.svg";
export { ForwardRef as ReactComponent };